/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Experiment_NoticeInputs */

const en_pricing_experiment_notice = /** @type {(inputs: Pricing_Experiment_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QA only. Overrides stay on this device and update the page immediately.`)
};

const es_pricing_experiment_notice = /** @type {(inputs: Pricing_Experiment_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo para pruebas. Los cambios se guardan en este dispositivo y actualizan la página de inmediato.`)
};

/**
* | output |
* | --- |
* | "QA only. Overrides stay on this device and update the page immediately." |
*
* @param {Pricing_Experiment_NoticeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_experiment_notice = /** @type {((inputs?: Pricing_Experiment_NoticeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Experiment_NoticeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_experiment_notice(inputs)
	return en_pricing_experiment_notice(inputs)
});